import * as Sentry from '@sentry/browser'

export function routerEnterTrack(orderInfo) {
  try {
    const {
      cityName,
      cityCode,
      priceInfo: { price },
      serviceDays,
      serviceTime,
      shareDetail: { shareCode },
      skuInfo: { skuId, skuName }
    } = orderInfo
    Sentry.captureMessage('comfirm_valet_order', scope => {
      scope.setTag('confirm_order', 'valet_order')
      scope.setContext('orderInfo', {
        cityName,
        cityCode,
        price,
        serviceDays,
        serviceTime,
        shareCode,
        skuId,
        skuName,
        time: new Date().toLocaleString()
      })
    })
  } catch (error) {
    console.error(error)
  }
}

export function payTrack(orderInfo) {
  Sentry.captureMessage('comfirm_valet_order', scope => {
    scope.setTag('confirm_order', 'valet_order_submit')
    scope.setContext('orderInfo', {
      ...orderInfo,
      time: new Date().toLocaleString()
    })
  })
}
